import { Controller } from "@hotwired/stimulus"
import { get, post, put, patch, destroy } from '@rails/request.js'

export default class extends Controller {
  static targets = [ "searchInput" ]
  static values = { productId: Number }

  async connect() {
  }

  showAddBundledProductsModal() {
    this.dispatch('showAddBundledProductsModal', { target: document })
    window.setTimeout(() => {
      this.searchInputTarget.focus()
    }, 120)
  }

  async searchInputKeydown() {
    await get(`/admin/products/${this.productIdValue}/search-bundled-product-items?q=${this.searchInputTarget.value}`, {
      responseKind: 'turbo-stream'
    })
  }

  async reloadPrice() {
    await get(`/admin/products/${this.productIdValue}/bundled-product-price-info`, {
      responseKind: 'turbo-stream'
    })
  }

  async addItem() {
    await post(`/admin/products/${this.productIdValue}/add-bundled-product-item`, {
      body: {
        bundled_product_item_id: event.params.bundledProductItemId
      },
      responseKind: 'turbo-stream'
    })

    Promise.all([
      get(`/admin/products/${this.productIdValue}/bundled-product-price-info`, {
        responseKind: 'turbo-stream'
      }),
      get(`/admin/products/${this.productIdValue}/search-bundled-product-items?q=${this.searchInputTarget.value}`, {
        responseKind: 'turbo-stream'
      })
    ])
  }

  async removeItem() {
    await post(`/admin/products/${this.productIdValue}/remove-bundled-product-item`, {
      body: {
        bundled_product_item_id: event.params.bundledProductItemId
      },
      responseKind: 'turbo-stream'
    })

    Promise.all([
      get(`/admin/products/${this.productIdValue}/bundled-product-price-info`, {
        responseKind: 'turbo-stream'
      }),
      get(`/admin/products/${this.productIdValue}/search-bundled-product-items?q=${this.searchInputTarget.value}`, {
        responseKind: 'turbo-stream'
      })
    ])
  }
}
